import { type Ref, useEffect, useRef } from 'react';

const useForwardedRef = <T>(ref?: Ref<T>) => {
  const innerRef = useRef<T>(null);

  useEffect(() => {
    if (!ref) return;
    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      // eslint-disable-next-line react-hooks/immutability
      ref.current = innerRef.current;
    }
  }, [ref]);

  return innerRef;
};

export default useForwardedRef;
